if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"frontend","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(138|282|439|791)|2(50|620|707|842|99)|5((04|31|87)4|911)|6(022|891|912)|7(148|207|324|47)|8(196|202|485|795|853|876|940)|9(109|282|803)|3997|407)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}